module.exports = __webpack_public_path__ + "img/video_1.ade67e69.png";